<template>
  <div class="local-login-grid">
    <div class="mb-12">
      <strong
        class="ml-6 return-back"
        @click.prevent="forgotPassword ? (forgotPassword = false) : $emit('returnToMainSignIn')"
      >
        <i class="fa-arrow-left fa-solid mr-2"></i>Atpakaļ
      </strong>
    </div>
    <div v-if="error" class="mb-6">
      <v-alert density="comfortable" type="error" variant="tonal">{{ error }}</v-alert>
    </div>
    <div v-if="forgotPassword" class="mb-6 text-h5">
      Ievadi savu e-pastu, un mēs nosūtīsim instrukcijas paroles atjaunošanai.
    </div>
    <div>
      <v-text-field
        ref="emailInput"
        v-model="email"
        prepend-inner-icon="fa-light fa-envelope"
        variant="outlined"
        placeholder="E-pasta adrese"
        border="md"
        type="email"
        :error="!loading && error"
        :readonly="loading"
        @keydown.enter="forgotPassword ? sendResetInstructions() : nextOrSubmit()"
      >
      </v-text-field>
    </div>
    <div v-if="!forgotPassword">
      <v-text-field
        ref="passwordInput"
        v-model="password"
        type="password"
        prepend-inner-icon="fa-light fa-key"
        variant="outlined"
        placeholder="Parole"
        :error="!loading && error"
        :readonly="loading"
        @keydown.enter="nextOrSubmit()"
      >
      </v-text-field>
    </div>
    <div v-if="!forgotPassword" class="forgot-password text-loginGray">
      <span @click.prevent="switchToForgot()"> Aizmirsi savu paroli?</span>
    </div>
    <div>
      <div class="login-btns mt-8">
        <div v-if="!forgotPassword" class="login-btn-cell">
          <v-btn
            class="v-btn-quiz"
            border="md"
            rounded="pill"
            flat
            variant="outlined"
            :disabled="loading"
            @click.prevent="goToSignUp()"
          >
            Reģistrēties
          </v-btn>
        </div>
        <div class="login-btn-cell">
          <v-btn
            class="v-btn-quiz"
            rounded="pill"
            flat
            color="yellowActive"
            :disabled="loading"
            @click.prevent="forgotPassword ? sendResetInstructions() : nextOrSubmit()"
          >
            {{ forgotPassword ? "Atjaunot paroli" : "Pieslēgties" }}
          </v-btn>
        </div>
      </div>
    </div>
    <login-password-recovery-notification :show="showPasswordRecoveryNotification" @close="closePasswordRecoveryNotification"></login-password-recovery-notification>
  </div>
</template>

<script>
import { useUserStore } from "~/stores/userStore"

export default {
  emits: ["returnToMainSignIn"],

  setup() {
    const userStore = useUserStore()
    return { userStore }
  },

  data() {
    return {
      forgotPassword: false,
      showPasswordRecoveryNotification: false,
      email: "",
      password: "",
      loading: false,
      error: null,
    }
  },

  computed: {
    config() {
      return useRuntimeConfig()
    },
  },

  methods: {
    nextOrSubmit() {
      if (!this.email && this.$refs.emailInput) {
        this.$refs.emailInput.focus()
        return
      }

      if (!this.password && this.$refs.passwordInput) {
        this.$refs.passwordInput.focus()
        return
      }

      this.submit()
    },

    submit() {
      this.loading = true
      this.userStore.login({
        email: this.email,
        password: this.password,
        successCallback: this.successfulLogin,
        errorCallback: this.errorOnLogin,
      })
    },

    goToSignUp() {
      window.location = `${this.config.public.oldFrontendRoot}registration`
    },

    successfulLogin() {
      this.loading = false
    },

    errorOnLogin(data) {
      this.error = data.message || data.status === 401 ? data.message || "Neizdevās pieteikties" : null
      this.loading = false
    },

    switchToForgot() {
      this.forgotPassword = true
      this.error = null
    },

    sendResetInstructions() {
      if (!this.email && this.$refs.emailInput) {
        this.$refs.emailInput.focus()
        return
      }

      this.loading = true
      this.userStore.requestPasswordReset({
        email: this.email,
        successCallback: this.successfulResetInstructions,
        errorCallback: this.errorOnInstructions,
      })
    },

    successfulResetInstructions() {
      this.loading = false
      this.showPasswordRecoveryNotification = true
      this.error = null
      this.email = ""
    },

    errorOnInstructions(data) {
      this.error = data.message || data.status === 401 ? data.message || "Neizdevās nosūtīt instrukcijas" : null
      this.loading = false
    },

    closePasswordRecoveryNotification() {
      this.showPasswordRecoveryNotification = false
      this.forgotPassword = false
    },
  },
}
</script>

<style lang="sass" scoped>
.local-login-grid
  display: flex
  align-self: center
  flex-direction: column
  width: 88%

.return-back
  cursor: pointer

.forgot-password
  z-index: 100
  font-size: 13px
  margin-top: -13px
  span
    padding-top: 4px
    padding-bottom: 2px
    cursor: pointer

.login-btns
  display: flex
  justify-content: flex-end
  gap: 8px
  flex-direction: row
</style>
